
  let mobileSwiper;
  const swiperContainer = document.getElementById('mobileProductSwiper');

  function initMobileSwiper() {
    debugger;
    if (window.innerWidth <= 767 && swiperContainer && !mobileSwiper) {
      mobileSwiper = new Swiper('#mobileProductSwiper', {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        
        zoom: {
    maxRatio: 3, 
  },
      });
    }
  }

  function destroyMobileSwiper() {
    if (mobileSwiper) {
      mobileSwiper.destroy(true, true);
      mobileSwiper = undefined;
    }
  }

  function checkSwiper() {
    if (window.innerWidth <= 767) {
      initMobileSwiper();
    } else {
      destroyMobileSwiper();
    }
  }

  checkSwiper();
  window.addEventListener('resize', checkSwiper);

